export default function NotFound() {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen text-center px-4 bg-slate-900">
        <h1 className="text-5xl md:text-7xl font-semibold text-white">404</h1>
        <h2 className="text-2xl md:text-3xl font-semibold mt-6 text-white">Página não encontrada</h2>
        <p className="mt-4 text-lg md:text-xl text-slate-400">A página que você está procurando não existe ou foi movida.</p>
      </div>
    );
  }